/**
 * Test ID utilities for Input component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for input fields
 * @param identifier - Input identifier (name, placeholder, or 'unnamed')
 * @returns Test ID string
 */
export const setInputTestId = (identifier: string): string =>
  generateTestId("Input", identifier.replace(/\s+/g, "-").toLowerCase());
